module.exports = __webpack_public_path__ + "img/invitees.7aaa684b.svg";